var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" WespiLift v."+_vm._s(_vm.appVersion)+". Copyright © 2019 PT. WESP Indonesia. All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }